import axios from "axios";
const api = process.env.REACT_APP_API_URL;
// export const base_url = "http://196.189.126.100:8085/api/";
// export default axios.create({ baseURL: "http://196.189.126.100:8085/api/" });
export default axios.create({ baseURL: api });
export const base_url = api;
// export default axios.create({
// 	baseURL: "https://production.crps.kacha.et:4343/api/dire/",
// });
// export const base_url = "https://production.crps.kacha.et:4343/api/dire/";
